export default "__VITE_ASSET__lPTMzy_C__"